export default __webpack_public_path__ + "0bf1063b53e498fe10a4a33bce56d127.svg";